// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__sqhSg","container":"styles_container__SfNN4","title":"styles_title__3UpIV","wrapper":"styles_wrapper__1Yv3a","answer":"styles_answer__uP4p5"};